import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

import { RequestService } from '../request';
import { IParameter, ParamType } from './defs';

interface IRawParameter {
  paramNo: number;
  paramText: string;
  paramValue: string;
}

@Injectable({
  providedIn: 'root',
})
export class ParametersService {

  private parameters$: BehaviorSubject<IParameter[]> = null;

  constructor(
    private request: RequestService
  ) {}

  public getParameters(types: ParamType[]): Observable<IParameter[]> {
    return this.request.get<IRawParameter[]>('/api/parameters').pipe(
      map(prms => {
        return prms.map(prm => ({
        paramType: prm.paramNo,
        value: prm.paramValue
      }));
      }),

      map(p => p.filter(pp => types.indexOf(pp.paramType) > -1))

    );
  }
}
